// extracted by mini-css-extract-plugin
export default {"container":"matrixOrder_container__Y9RNl","matrixTableWrapper":"matrixOrder_matrixTableWrapper__+7tx+","matrixOrderSummary":"matrixOrder_matrixOrderSummary__CSfly"};